import { EDateFormat } from '../../shared/enums/date-format.enum';

export const DEFAULT_DATE_FORMAT = EDateFormat.ISO;
